const codes = {
  'CL-ACCEPTED': 10,
  'CL-DELIVERED': 9,
  'CL-INVOICED': 33,
  'CLIENT-CAN': 11,
  'FR-ACCEPTED': 3,
  'FR-ASSIGNED': 2,
  'FR-COMPLETED': 5,
  'FR-REJECTED': 34,
  'FR-SCHEDULED': 4,
  'FR-UNASSIGNED': 14,
  'NPC-CAN': 12,
  'NPCV-CAN': 13,
  'OR-NEW': 1,
  'PENDING': 35,
  'QA-ASSIGNED': 7,
  'QA-COMPLETED': 8,
  'QA-QUEUED': 6,
  'CALL-HOLD': 36,
  'CALL-RELEASE': 37,
  'CL-RETURNED' : 38,
  'PO-ASSIGNED': 39,
  'IQ-PENDING': 41,
};

const sortedCodes = Object.keys(codes)
  .sort()
  .reduce((acc, key) => {
    acc[key] = codes[key];
    return acc;
  }, {});

export default sortedCodes;
